import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked-circle-3--sprite",
  "use": "checked-circle-3--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checked-circle-3--sprite\">\n<rect x=\"0\" y=\"0\" width=\"32\" height=\"32\" rx=\"16\" fill=\"var(--Brand-Orange)\" />\n<path d=\"M14.0001 18.78L11.2201 16L10.2734 16.94L14.0001 20.6667L22.0001 12.6667L21.0601 11.7267L14.0001 18.78Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol